import React from 'react';

export function CataloniaFlag({ className }) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 810 540"
      className={className}
    >
      <rect width="810" height="540" fill="#FCDD09"/>
      <path stroke="#DA121A" strokeWidth="60" d="M0,90H810m0,120H0m0,120H810m0,120H0"/>
    </svg>
  );
}
